import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Popconfirm, Select, Table } from 'antd';
import { Breadcrumb } from 'antd';
import BreadCrumb from '../../../Shared/Components/BreadCrumb/BreadCrumb';


const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current?.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};
export default function ListEntry() {
    const [dataSource, setDataSource] = useState([
        {
            key: '0',
            col1: 'CF CFU/g',
            col2: 'CF CPU/g',
            col3: 'T CFU/g',
        },
        {
            key: '1',
            col1: 'CF CFU/g',
            col2: 'CF CPU/gg',
            col3: 'T CFU/g',
        },
    ]);

    const defaultColumns = [
        {
            title: 'col1',
            dataIndex: 'col1',
            width: 'auto',
            editable: true,
        },
        {
            title: 'col2',
            dataIndex: 'col2',
            editable: true,
        },
        {
            title: 'col3',
            dataIndex: 'col3',
            editable: true,
        },
    ];

    const handleSave = (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        console.log("Hello")
        setDataSource(newData);
    };
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });


    // Category Dropdown
    const items = [
        {
            "value": "fg_inclusion",
            "label": "FG - IC With Inclusion"
        },
        {
            "value": "fg_without_inclusion",
            "label": "FG - IC Without Inclusion"
        },
        {
            "value": "fg_bites",
            "label": "FG - IC Bites"
        },
        {
            "value": "fg_cake",
            "label": "FG - IC Cake"
        }
    ]

    const onChange = (value) => {
        let tempData = [{
            key: '0',
            col1: 'CF CFU/g',
            col2: 'CF CPU/g',
            col3: 'T CFU/g',
        },
        {
            key: '1',
            col1: 'CF CFU/g',
            col2: 'CF CPU/gg',
            col3: 'T CFU/g',
        },
        {
            key: '2',
            col1: 'ES CFU/g',
            col2: 'M CPU/gg',
            col3: 'T CFU/g',
        },
        {
            key: '3',
            col1: 'CF CFU/g',
            col2: 'CF CPU/gg',
            col3: 'T CFU/g',
        },
        ]
        if(value === 'fg_inclusion'){
            setDataSource(tempData);
        } else {
            tempData = [
                {
                    key: '0',
                    col1: 'CF CFU/g',
                    col2: 'CF CPU/g',
                    col3: 'T CFU/g',
                },
                {
                    key: '1',
                    col1: 'CF CFU/g',
                    col2: 'CF CPU/gg',
                    col3: 'T CFU/g',
                },
            ]
            setDataSource(tempData);
        }
        console.log(`selected ${value}`);
    };
    const onSearch = (value) => {
        console.log('search:', value);
    };

    //BreadCrumb Items
    const breadCrumbitems =[
        {
          title: <a href="/dashboard">Dashboard</a>,
        },
        {
          title:<a href="/microParameterEntry">Micro Parameter Entry</a> ,
        },
        {
          title: 'View Category Readings',
        }
      ]

    return (
        <>
        <BreadCrumb items={breadCrumbitems} className='m-2 mx-4' />
        <div className='mainContent'>
            <div className='d-flex' style={{ flexGrow: 1, alignItems: 'center', justifyContent: 'space-between' }}>
                <h1 className="subHeader" style={{ flexGrow: 1 }}>Category Readings</h1>
                <label className="subHeader m-0 mx-2">Manual Category : </label>
                <Select
                    style={{ width: '30vh' }}
                    showSearch
                    placeholder="Select Category"
                    optionFilterProp="label"
                    onChange={onChange}
                    onSearch={onSearch}
                    options={items}
                />
            </div>
            <Table
                showHeader={false}
                components={components}
                rowClassName={() => 'editable-row'}
                bordered
                dataSource={dataSource}
                columns={columns}
            />
        </div>
        </>
    );
};